<!-- general-settings.component.html -->
<form [formGroup]="generalSettingsForm" (ngSubmit)="onSubmit()" class="general-settings-form">
  <mat-form-field appearance="outline" class="x-small-input field">
    <mat-label>Job Pictures</mat-label>
    <input
      matInput
      type="number"
      formControlName="minDriverPictures"
      title="Minimum number of pictures required to complete a job" />
    <mat-error *ngIf="generalSettingsForm.get('minDriverPictures')?.hasError('required')">
      This field is required
    </mat-error>
    <mat-error *ngIf="generalSettingsForm.get('minDriverPictures')?.hasError('min')">
      Minimum value is 1
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="field">
    <mat-label>Summary Note</mat-label>
    <textarea matInput formControlName="summaryNote" rows="3" 
      placeholder='Summary note text' title="Message displayed to the end customer in the summary page."></textarea>
    <mat-error *ngIf="generalSettingsForm.get('summaryNote')?.hasError('required')">
      Summary note is required
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="field">
    <mat-label>Proof of delivery message</mat-label>
    <textarea matInput formControlName="deliveryProof" rows="3" 
      placeholder='Proof of delivery message text' title="Message displayed to the customer next to the customer's signature."></textarea>
    <mat-error *ngIf="generalSettingsForm.get('deliveryProof')?.hasError('required')">
      Proof of delivery message is required
    </mat-error>
  </mat-form-field>

  <mat-slide-toggle formControlName="hideAndSkipDOTForm">
    Skip questions
  </mat-slide-toggle>

  <div class="min-chars-container">
    <span>Minimum number of characters</span>
    <div>
      <mat-form-field appearance="outline" class="min-chars-field">
        <mat-label>Failed Job Note</mat-label>
        <input
          matInput
          type="number"
          formControlName="minCharsFailedJobNote"
          title="Minimum number of characters required in failed job note" />
          <mat-error *ngIf="generalSettingsForm.get('minCharsFailedJobNote')?.hasError('required')">
            This field is required
          </mat-error>
          <mat-error *ngIf="generalSettingsForm.get('minCharsFailedJobNote')?.hasError('min')">
            Minimum value is 1
          </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="min-chars-field">
        <mat-label>Reject Comment</mat-label>
        <input
          matInput
          type="number"
          formControlName="minCharsRejectComment"
          title="Minimum number of characters required in reject comment" />
          <mat-error *ngIf="generalSettingsForm.get('minCharsRejectComment')?.hasError('required')">
            This field is required
          </mat-error>
          <mat-error *ngIf="generalSettingsForm.get('minCharsRejectComment')?.hasError('min')">
            Minimum value is 1
          </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="min-chars-field">
        <mat-label>Visit Summary Note</mat-label>
        <input
          matInput
          type="number"
          formControlName="minCharsSummaryNote"
          title="Minimum number of characters required in summary note" />
          <mat-error *ngIf="generalSettingsForm.get('minCharsSummaryNote')?.hasError('required')">
            This field is required
          </mat-error>
          <mat-error *ngIf="generalSettingsForm.get('minCharsSummaryNote')?.hasError('min')">
            Minimum value is 1
          </mat-error>
      </mat-form-field>
    </div>
  </div>
  
  <div class="questions-container" cdkDropList>
    <div class="questions-controls">
      <span>Questions</span>
      <button mat-raised-button color="primary" class="tiny-button" type="button" (click)="$event.stopPropagation(); editItem({})">
        <mat-icon>add</mat-icon>
      </button>
    </div>
    <div class="questions-list">
      <div *ngFor="let question of generalSettingsForm.get('dotForm').value" class="question-item" cdkDrag [cdkDragData]="question" (cdkDragDropped)="dropped($event)">
        <div class="question-field-small" [style.backgroundColor]="question.type === 'text' && question.auto === 'date' ? '#ffbe00fc' : (question.type === 'text' ? '#32db64' : '#f53d3d')">
          {{question.type === 'text' && question.auto === 'date' ? 'datetime' : question.type}}
        </div>
        <div class="question-field-expand">{{question.question}}</div>
        <div class="question-buttons">
          <div class="edit-delete-buttons">
            <app-icon name="pencil" class="icon-button" (click)="$event.stopPropagation(); editItem(question)"></app-icon>
            <app-icon name="close-window-cross" class="icon-button" (click)="$event.stopPropagation(); removeItem(question)"></app-icon>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="form-actions">
    <button mat-raised-button color="primary" type="submit">Save Changes</button>
  </div>
</form>